import { Suspense } from 'react';
import { FormLoadingOverlay } from '../forms/components/FormLoadingOverlay/FormLoadingOverlay';

export const CustomSuspense = ({ children }) => <Suspense fallback={<FormLoadingOverlay />}>{children}</Suspense>;
